// @ts-strict-ignore
import { inject, injectWithTransform, singleton } from "tsyringe";
import {
  ContextRepository,
  FandomContextGroups,
  Logger,
  LoggerTransformer,
} from "@identity/utils";
import { LiveConnect } from "./live-connect";

@singleton()
export class PartnersService {
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "Partners")
    private readonly logger: Logger,
    @inject(ContextRepository) private contextRepository: ContextRepository,
    @inject(LiveConnect) private readonly liveConnect: LiveConnect,
  ) {}

  createPartnersContext() {
    this.contextRepository.set(FandomContextGroups.partners, "anyclip", {
      value: {
        ppid: this.contextRepository.get(FandomContextGroups.tracking, "ppid"),
      },
    });
  }

  async initializeTargetingPartners(): Promise<void> {
    // TODO: Move Audigent, LiveRamp
  }

  async initializeTrackingPartners(): Promise<void> {
    // TODO: Move Eyeota here
    this.logger.info("Initializing partners");
    await Promise.all([this.liveConnect.init()]);
  }
}
